import appConfig from 'app.config'
import i18n from 'i18n'
import {
	CountryValuesProductType,
	ICountryValues,
} from 'constants/countryValueTypes'
import { nameof } from 'exports'

export const countryValues: ICountryValues[] = [
	{
		country: 'dk',
		tfFullName: 'TF Bank',
		copyRight: 'TF Bank AB, Danmark',
		links: () => {
			return {
				about: { link: 'https://tfbank.dk/om-tf-bank' },
				cookie: {
					link: 'https://tfbank.dk/om-tf-bank/cookies-og-sikkerhed',
				},
			}
		},
		address: {
			companyName: 'TF Bank AB',
			addressLine1: 'Box 947',
			zipCodeAndCity: '501 10, Borås',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.All,
				contactInformation: {
					email: 'info@tfbank.dk',
					phoneNumber: '78 73 04 60',
				},
			},
		],
	},
	{
		country: 'ee',
		tfFullName: 'TF Bank',
		copyRight: 'TF Bank Kõik õigused kaitstud',
		links: () => {
			return {
				about: { link: 'https://tfbank.ee/kes-me-oleme/' },
				cookie: {
					link: 'https://www.tfbank.ee/klienditeenindus/kliendiandmete-tootlemise-kord/',
				},
			}
		},
		address: {
			postalAddress: 'PostalAddress',
			companyName: 'TF Bank AB (publ.) Eesti filiaal',
			addressLine1: 'Vabaõhumuuseumi tee 1',
			zipCodeAndCity: '13521 Tallinn',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.All,
				contactInformation: {
					email: 'info@tfbank.ee',
					phoneNumber: '607 5775',
				},
			},
		],
	},
	{
		country: 'fi',
		tfFullName: 'TF Bank AB, Suomen sivuliike (2594352-3)',
		copyRight: 'TF Bank AB, Ruotsi',
		links: () => {
			return {
				about: { link: 'https://www.tfbank.fi/tietoa-tf-bankista/' },
				cookie: { link: 'https://tfbank.fi/evasteet' },
				loanSecurity: {
					link: 'https://www.tfbank.fi/lainat/lainaturva',
				},
			}
		},
		address: {
			companyName: 'TF Bank AB, Suomen sivuliike',
			addressLine1: 'Y-tunnus 2594352-3',
			addressLine2: 'PL 5600',
			zipCodeAndCity: '00002, Helsinki',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.All,
				contactInformation: {
					email: 'info@tfbank.fi',
					phoneNumber: '0206 90591',
					phoneNumber2: '0206 90681',
				},
			},
		],
	},
	{
		country: 'lt',
		tfFullName: 'TF Bank',
		copyRight: 'TF Bank AB, Sweden',
		links: () => {
			return {
				about: { link: 'https://tfbank.lt/apie-tf-bank-ab' },
				forms: { link: 'https://tfbank.lt/prasymu-formos' },
				financialDifficulties: {
					link: 'https://tfbank.lt/susidurus-su-finansiniais-sunkumais',
				},
				consumerLoan: { link: 'https://tfbank.lt/vartojimo-paskola' },
				cookie: { link: 'https://tfbank.lt/slapukai' },
			}
		},
		address: {
			companyName: 'TF Bank Lietuvos filialas',
			addressLine1: 'Lvivo g. 25',
			zipCodeAndCity: 'LT-09320, Vilnius',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.All,
				contactInformation: {
					email: 'info@tfbank.lt',
					phoneNumber: '1899',
				},
			},
		],
	},
	{
		country: 'lv',
		tfFullName: 'TF Bank',
		copyRight: 'TF Bank AB, Sweden',
		links: () => {
			return {
				about: { link: 'https://tfbank.lv/par-tf-bank' },
				cookie: { link: 'https://tfbank.lv/privatuma-politika' },
				cashLoan: {
					link:
						i18n.language === nameof('ru-LV', appConfig.languages)
							? 'https://tfbank.lv/ru/denezhnyi-kredit'
							: 'https://tfbank.lv/naudas-kredits',
				},
				carLoan: {
					link:
						i18n.language === nameof('ru-LV', appConfig.languages)
							? 'https://tfbank.lv/ru/avtokredit'
							: 'https://tfbank.lv/auto-kredits',
				},
				renovationLoan: {
					link:
						i18n.language === nameof('ru-LV', appConfig.languages)
							? 'https://tfbank.lv/ru/kredit-na-remont'
							: 'https://tfbank.lv/kredits-remontam',
				},
				refinance: {
					link:
						i18n.language === nameof('ru-LV', appConfig.languages)
							? 'https://tfbank.lv/ru/perekreditafiya'
							: 'https://tfbank.lv/parkreditacija',
				},
			}
		},
		address: {
			companyName: 'TF Bank AB Latvijas filiāle',
			addressLine1: 'Dēļu iela 4',
			zipCodeAndCity: 'Rīga, LV-1004',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.All,
				contactInformation: {
					email: 'info@tfbank.lv',
					email2: 'kavejums@tfbank.lv',
					phoneNumber: '66 090 800',
					phoneNumber2: '66 090 808',
				},
			},
		],
	},
	{
		country: 'se',
		tfFullName: 'TF Bank',
		copyRight: 'TF Bank AB, Sverige',

		links: () => {
			return {
				about: { link: 'https://www.tfbank.se/om-tf-bank/' },
				cookie: {
					link: 'https://tfbank.se/om-tf-bank/cookies-och-sakerhet',
				},
			}
		},
		address: {
			companyName: 'TF Bank AB',
			addressLine1: 'Box 947',
			zipCodeAndCity: '501 10, Borås',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.All,
				contactInformation: {
					email: 'info@tfbank.se',
					phoneNumber: '033-722 35 00',
				},
			},
		],
	},

	{
		country: 'no',
		tfFullName: 'TF Bank Norge',
		copyRight: 'TF Bank AB, Sverige',

		links: () => {
			return {
				about: { link: 'https://tfbank.no/om-oss/'},
				cookie: { link: 'https://www.tfbank.no/personvernerklaring/' },
				faq: { link: 'https://tfbank.no/hjelp' },
			}
		},
		address: {
			companyName: 'TF Bank Norge',
			addressLine1: 'Postboks 956 Sentrum',
			zipCodeAndCity: '5808, Bergen',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.All,
				contactInformation: {
					email: 'post@tfbank.no',
					phoneNumber: '56 99 92 00',
				},
			},
		],
	},
]